var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2606 14.0275L12.3666 14.1378L12.4748 14.0296L13.5061 12.9984L13.6118 12.8926L13.5064 12.7866L9.90625 9.16379V4.6194V4.4694H9.75625H8.38125H8.23125V4.6194V9.77565V9.83606L8.27312 9.87961L12.2606 14.0275ZM6.38849 18.0832C7.52313 18.5728 8.72744 18.8173 10 18.8173C11.2726 18.8173 12.4769 18.5728 13.6115 18.0832C14.7436 17.5946 15.7336 16.9271 16.58 16.0807C17.4265 15.2342 18.094 14.2443 18.5825 13.1122C19.0721 11.9775 19.3167 10.7732 19.3167 9.50065C19.3167 8.22809 19.0721 7.02378 18.5825 5.88914C18.094 4.75701 17.4265 3.7671 16.58 2.92063C15.7336 2.07416 14.7436 1.40665 13.6115 0.918134C12.4769 0.42853 11.2726 0.183984 10 0.183984C8.72744 0.183984 7.52313 0.42853 6.38849 0.918134C5.25637 1.40665 4.26645 2.07416 3.41998 2.92063C2.57351 3.7671 1.90601 4.75701 1.41749 5.88914C0.927882 7.02378 0.683336 8.22809 0.683336 9.50065C0.683336 10.7732 0.927882 11.9775 1.41749 13.1122C1.90601 14.2443 2.57351 15.2342 3.41998 16.0807C4.26645 16.9271 5.25637 17.5946 6.38849 18.0832ZM15.3939 14.8946C13.894 16.3946 12.0987 17.1423 10 17.1423C7.90135 17.1423 6.10604 16.3946 4.60607 14.8946C3.1061 13.3946 2.35834 11.5993 2.35834 9.50065C2.35834 7.402 3.1061 5.60669 4.60607 4.10672C6.10604 2.60675 7.90135 1.85898 10 1.85898C12.0987 1.85898 13.894 2.60675 15.3939 4.10672C16.8939 5.60669 17.6417 7.402 17.6417 9.50065C17.6417 11.5993 16.8939 13.3946 15.3939 14.8946Z",
    fill: "#000A62",
    stroke: "#000A62",
    strokeWidth: 0.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.71192d3eb1bee37ab861145ae782bfd4.svg";
export { ForwardRef as ReactComponent };